var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F67676"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.545 18.908a1.09 1.09 0 010 2.182H13.454a1.09 1.09 0 110-2.182h13.09z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNGNjc2NzYiLz4KPHBhdGggZD0iTTI2LjU0NDggMTguOTA4MkMyNy4xNDczIDE4LjkwODIgMjcuNjM1NyAxOS4zOTY2IDI3LjYzNTcgMTkuOTk5MVYxOS45OTkxQzI3LjYzNTcgMjAuNjAxNiAyNy4xNDczIDIxLjA5IDI2LjU0NDggMjEuMDlMMTMuNDUzOSAyMS4wOUMxMi44NTE0IDIxLjA5IDEyLjM2MyAyMC42MDE2IDEyLjM2MyAxOS45OTkxVjE5Ljk5OTFDMTIuMzYzIDE5LjM5NjYgMTIuODUxNCAxOC45MDgyIDEzLjQ1MzkgMTguOTA4MkwyNi41NDQ4IDE4LjkwODJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgBlocked as ReactComponent };